<template>
  <div class="spinner">
    <img src="../assets/loading.svg" alt="loading"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'callback',
    data () {
      return {}
    },
    computed: {
      ...mapState([
        'auth'
      ])
    },
    mounted () {
      this.auth.handleAuthentication()
    }
  }
</script>

<style lang="scss" scoped>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    img {
      width: 120px;
      height: 120px;
      -webkit-animation:spin 1000ms linear infinite;
      -moz-animation:spin 1000ms linear infinite;
      animation:spin 1000ms linear infinite;
    }
  }

  @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
  @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
  @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
</style>



// WEBPACK FOOTER //
// Callback.vue?a2e08530